module.exports = __webpack_public_path__ + "img/HowItWork_item_01.b4863b9a.png";